export const unsanitize = (string: string) => {
	const cleaned = string.replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
	return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};
